import Glide from '@glidejs/glide'

export const initHomeHeroSlide = () => {
  new Glide('.home-hero-slide').mount()
}